<template>
    <b-table
        responsive
        striped
        hover
        small
        show-empty
        empty-text="Аукционы не найдены"
        class="lots-table custom-table"
        label-sort-asc=""
        label-sort-desc=""
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :items="items"
        :fields="tableFields"
        @row-clicked="routeToLot"
        @sort-changed="sortChanged"
    >
        <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
                <b-spinner variant="primary" class="align-middle"></b-spinner>
                <strong>Загрузка аукционов...</strong>
            </div>
        </template>
        <template v-slot:cell(name)="data">
            <auction-list-description :lot="data.item"/>
        </template>
        <template v-slot:cell(pivot_accepted)="data">
            {{ getAcceptedStatus(data.item) }}
        </template>
    </b-table>
</template>

<script>
import AuctionListDescription from '@features/Lots/AuctionListDescription'
import {formatDate} from '@/filters'
import {routeToLot} from '@/helpers/router-helpers'
import authRolesMixin from "@/helpers/authRolesMixin";

export default {
    name: "LotsTable",
    components: {AuctionListDescription},
    mixins: [authRolesMixin],
    props: {
        items: {
            type: Array,
            required: true,
        },
        fromUser: {
            type: Boolean,
        },
        sortBy: {},
        sortDesc: {},
    },
    computed: {
        tableFields() {
            const tableFields = [
                {
                    key: "id",
                    label: "№",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "text-center",
                    thStyle: "width: 50px"
                },
                {
                    key: "name",
                    label: "Наименование торговой процедуры",
                    thClass: "text-center"
                },
                {
                    key: "start_price",
                    label: "Начальная цена",
                    sortable: true,
                    formatter: (value) => (+value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB'}),
                    tdClass: "text-right",
                    thClass: "text-center",
                    thStyle: "width: 150px"
                },
                {
                    key: "submitting_end",
                    label: "Прием заявок до",
                    sortable: true,
                    formatter: (value) => formatDate(value,"dd.MM.yyyy"),
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "width: 130px"
                },
                {
                    key: "date_start",
                    label: "Дата проведения",
                    sortable: true,
                    formatter: (value) => formatDate(value,"dd.MM.yyyy"),
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "width: 130px"
                }
            ]

            if (this.hasNotAcceptedUsers || this.userIsAdminOperator || this.userIsOrganizer) {
                tableFields.push(
                    { key: "not_accepted_users_requests_count",
                        label: "Заявок на согласовании",
                        sortable: true,
                        formatter: (value) => value ? value : '',
                        tdClass: "text-center",
                        thClass: "text-center",
                        thStyle: "width: 135px"
                    },
                    { key: "lot_requests_count",
                        label: "Заявок всего",
                        sortable: true,
                        formatter: (value) => value ? value : '',
                        tdClass: "text-center",
                        thClass: "text-center",
                        thStyle: "width: 135px"
                    }
                )
            }
            if (this.fromUser) {
                tableFields.push({
                    key: "pivot_accepted",
                    label: "Статус участия",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "width: 150px"
                })
            }
            return tableFields
        },

        hasNotAcceptedUsers() {
            return this.items.some(item => item.not_accepted_users_requests_count)
        }
    },
    methods: {
        sortChanged(data) {
            this.$emit('sort-changed', data)
        },
        routeToLot(item) {
            const to = routeToLot(item.id, this.$auth.watch?.data?.role)
            this.$router.push(to)
        },
        getAcceptedStatus(item) {
            return !!item.pivot?.accepted ? 'Подтверждено' : 'Заявка подана'
        }
    },
};
</script>
